import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackCustomFilterEvents = createAnalyticsTracker('customFilter');
